import { Button } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";

const EDITAR = "Editar"
const NUEVO = "Nuevo"

export const BotonEditar = ({ onClick }: { onClick: () => void }) => (
    <Button size={'small'} color='primary' variant='contained' onClick={onClick} startIcon={<EditIcon fontSize={'small'} />}>{EDITAR}</Button>
)

export const BotonAgregar = ({ onClick }: { onClick: () => void }) => (
    <Button size="small" color='primary' variant='contained' onClick={onClick} startIcon={<AddIcon fontSize={"small"} />}>{NUEVO}</Button>
)